export const ADVANTAGES_LIST: string[] = [
	'0 грн відкриття та обслуговування картки',
	'0% комісії ГК «Нафтогаз»',
	'0% комісії ПрАТ «Харківенергозбут»',
	'0% комісії КП «Харківські теплові мережі»',
	'0% комісії КП «Комплекс з вивозу побутових відходів»',
	'0% комісії КП «Житлокомсервіс»',
];
